import { EventCollectionDTO } from '@/api/event/dto/events/EventCollectionDTO'
import { EventCollection } from '@/model/EventCollection'
import { EventFactory } from './EventFactory'

export class EventCollectionFactory {
  static fromDTO(dto: EventCollectionDTO): EventCollection {
    return new EventCollection(dto.events.map(EventFactory.fromDTO), dto.totalEvents)
  }
}
